import styles from "./styles.module.scss";

export const MissionCriticalServices = ({ subtitle, title, description, services }) => {
  return (
    <section className={styles.MissionCriticalServices}>
      <div className={styles.header}>
        <div className={styles.subtitle} data-sourceflow-prop="subtitle">
          {subtitle}
        </div>
        <div className={styles.title} data-sourceflow-prop="title">
          {title}
        </div>
        <div
          className={styles.description}
          data-sourceflow-prop="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      <div className={styles.cards}>
        {services.map(({ label, image }, idx) => (
          <div key={idx} className={styles.card} style={{ backgroundImage: `url(${image?.url})` }}>
            <h3>{label}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MissionCriticalServices;
